import { render, staticRenderFns } from "./xhdpage-script.vue?vue&type=template&id=6c8a2868&scoped=true&"
import script from "./xhdpage-script.vue?vue&type=script&lang=js&"
export * from "./xhdpage-script.vue?vue&type=script&lang=js&"
import style0 from "./xhdpage-script.vue?vue&type=style&index=0&id=6c8a2868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a2868",
  null
  
)

export default component.exports